import { render, staticRenderFns } from "./optionbutton.vue?vue&type=template&id=1a78bc5b&"
import script from "./optionbutton.vue?vue&type=script&lang=js&"
export * from "./optionbutton.vue?vue&type=script&lang=js&"
import style0 from "./optionbutton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports